<tui-theme-night *ngIf="night | async"></tui-theme-night>

<tui-loader [showLoader]="(isLoading | async) || false" [overlay]="(isLoading | async) || false">
  <tui-root [tuiMode]="mode">
    <router-outlet></router-outlet>
  </tui-root>
</tui-loader>
